const changeCart = async (lineItemKey, qty) => {
  const item = {
    id: lineItemKey,
    quantity: qty
  };

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item)
    });
    const changedItem = await response.json();
    return changedItem.key;
  } catch (err) {
    console.error('Add to cart error:', err);
  }
};

export default changeCart;
